/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ContactEventConfigType = {
    Data: 'data',
    Script: 'script',
    Rule: 'rule'
} as const;
export type ContactEventConfigType = typeof ContactEventConfigType[keyof typeof ContactEventConfigType];


export function ContactEventConfigTypeFromJSON(json: any): ContactEventConfigType {
    return ContactEventConfigTypeFromJSONTyped(json, false);
}

export function ContactEventConfigTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactEventConfigType {
    return json as ContactEventConfigType;
}

export function ContactEventConfigTypeToJSON(value?: ContactEventConfigType | null): any {
    return value as any;
}

